import { Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/Login';
import DashboardPage from './pages/Dashboard';
import AdminsPage from './pages/Admins';
import AdminFormPage from './pages/AdminForm';
import QuestionsPage from './pages/Questions';
import QuestionFormPage from './pages/QuestionForm';
import BlogPostsPage from './pages/BlogPosts';
import BlogPostFormPage from './pages/BlogPostForm';
import ProfilePage from './pages/Profile';
import NotFoundPage from './pages/NotFound';
import TaxonomiesPage from './pages/Taxonomies';
import useAuthStore from './store/auth';

const AppRoutes = () => {
  const { isAuthenticated, isInitialized, user } = useAuthStore();
  const isSuperAdmin = user?.role === 'super_admin';

  // Wait for auth initialization before rendering routes
  if (!isInitialized) {
    return null; // Or a loading spinner
  }

  // Define routes based on auth state
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  const isAdminOrSuper = user?.role === 'admin' || user?.role === 'super_admin';

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/dashboard" replace />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/profile" element={<ProfilePage />} />

      {isSuperAdmin && (
        <>
          <Route path="/admins" element={<AdminsPage />} />
          <Route path="/admins/new" element={<AdminFormPage />} />
          <Route path="/admins/:id/edit" element={<AdminFormPage />} />
        </>
      )}

      {isAdminOrSuper && (
        <>
          <Route path="/taxonomies" element={<TaxonomiesPage />} />
          <Route path="/questions/new" element={<QuestionFormPage />} />
          <Route path="/questions/:id/edit" element={<QuestionFormPage />} />
        </>
      )}

      <Route path="/questions" element={<QuestionsPage />} />

      <Route path="/blog" element={<BlogPostsPage />} />
      <Route path="/blog/new" element={<BlogPostFormPage />} />
      <Route path="/blog/:id/edit" element={<BlogPostFormPage />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;